import { privateAPI } from '.';

export const docuSyncAPI = privateAPI.injectEndpoints({
  endpoints: build => ({
    listDocuFolders: build.query({
      query: params => ({
        url: '/client-portal/doc-sync/folders',
        method: 'GET',
        params: {
          page: params?.page || 1,
          // query: params?.search || '',
        },
      }),
      providesTags: ['ListDocuFolders'],
    }),
    showFolder: build.query({
      query: ({ id }) => `/client-portal/doc-sync/folders/${id}`,
      providesTags: ['ShowFolder'],
    }),
    createFolder: build.mutation({
      query: payload => ({
        url: '/client-portal/doc-sync/create-folder',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['ListDocuFolders'],
    }),
    renameFolder: build.mutation({
      query: ({ id, ...body }) => {
        const formData = new FormData();

        formData.append('name', body.name);
        formData.append('_method', 'PUT');

        return {
          url: `client-portal/doc-sync/folders/${id}`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['ListDocuFolders'],
    }),
    deleteFolder: build.mutation({
      query: ({ id }) => ({
        url: `/client-portal/doc-sync/delete-folder/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ListDocuFolders'],
    }),
    uploadFiles: build.mutation({
      query: formData => ({
        url: '/client-portal/doc-sync/upload-files',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['ListDocuFolders', 'ShowFolder'],
    }),
    updateFile: build.mutation({
      query: ({ payload, fileId }) => ({
        url: `client-portal/doc-sync/update-files/${fileId}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['ListDocuFolders', 'ShowFolder'],
    }),
    deleteFile: build.mutation({
      query: ({ id }) => ({
        url: `/client-portal/doc-sync/delete-file/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ListDocuFolders', 'ShowFolder'],
    }),
    markDocuSyncAsRead: build.mutation({
      query: ({ folderId } = {}) => ({
        url: '/client-portal/docu-sync/mark-as-read',
        method: 'POST',
        body: folderId ? { folder_id: folderId } : undefined,
      }),
    }),
  }),
});

export const {
  useListDocuFoldersQuery,
  useShowFolderQuery,
  useCreateFolderMutation,
  useRenameFolderMutation,
  useDeleteFolderMutation,
  useUploadFilesMutation,
  useUpdateFileMutation,
  useDeleteFileMutation,
  useMarkDocuSyncAsReadMutation,
} = docuSyncAPI;
